<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>充值管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="卡片类型:">
        <el-select v-model="formInline.is_general">
          <el-option label="专属卡片" value="0"></el-option>
          <el-option label="通用卡片" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="场地名称:">
        <el-select v-model="formInline.exclusive_field_id" placeholder="请选择场地名称" clearable>
          <el-option v-for="item in station_names" :label="item.station_name" :value="item.id" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态:">
        <el-select v-model="formInline.state">
          <el-option label="启用中" value="1"></el-option>
          <el-option label="已停用" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="getdata()">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="id" label="序号" >
      </el-table-column>
      <el-table-column sortable prop="recharge_amount" label="充值金额（元）" >
        <template slot-scope="scope" >
          {{ scope.row.recharge_amount/100 }}
        </template>
      </el-table-column>
      <el-table-column sortable prop="gift_amount" label="赠送金额（元）" >
        <template slot-scope="scope" >
          {{ scope.row.gift_amount/100 }}
        </template>
      </el-table-column>
      <el-table-column sortable prop="is_general" label="卡片类型" >
        <template slot-scope="scope" >
          {{ scope.row.is_general == 1 ?'通用卡片' :'专属卡片'}}
        </template>
      </el-table-column>
      <el-table-column sortable prop="exclusive_field_id" label="专属场地" >
        <template slot-scope="scope" >
          {{ scope.row.is_general == 1 ?'-' :'-'}}
        </template>
      </el-table-column>
      <el-table-column sortable prop="state" label="状态">
        <template slot-scope="scope">
          <el-button size="mini" v-if="scope.row.state == 1" type="success">启用中</el-button>
          <el-button size="mini" type="danger" v-if="scope.row.state == 0 ">已停用</el-button>
        </template>

      </el-table-column>
      <el-table-column align="center" label="操作" min-width="200">
        <template slot-scope="scope">
          <el-button size="mini"  type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteCards(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="充值金额 ( 元 )" prop="recharge_amount">
          <el-input size="small" v-model="editForm.recharge_amount"  placeholder="请输入充值金额"></el-input>
        </el-form-item>
        <el-form-item label="赠送金额 ( 元 )" prop="gift_amount">
          <el-input size="small" v-model="editForm.gift_amount"  placeholder="请输入赠送金额"></el-input>
        </el-form-item>
        <el-form-item label="卡片类型:">
        <el-select v-model="editForm.is_general">
            <el-option label="专属卡片" value="0"></el-option>
            <el-option label="通用卡片" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专属场地" prop="exclusive_field_id">
          <el-select v-model="editForm.exclusive_field_id" placeholder="请选择场地名称" v-if="editForm.is_general == 0">
            <el-option v-for="item in station_names" :label="item.station_name" :value="item.id" :key="item.id"></el-option>
          </el-select>
          <el-input size="small"  placeholder="卡片类型为专属卡片时，必填" v-if="editForm.is_general != 0" disabled></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="state">
          <el-select v-model="editForm.state">
            <el-option label="启用中" value="1"></el-option>
            <el-option label="已停用" value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getStationNames,getStation,addStation,updateStation,deleteStation } from '../../api/station'

import { getCards,addCards,updateCards,deleteCards} from '../../api/cards'
import { getPrice,get_suppliers_name } from '../../api/price'

import { deptList, deptSave, deptDelete } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import {
  pcaTextArr,
} from "element-china-area-data";
export default {
  data() {
    return {
      priceList:[],
      suppliers_names:[],
      pcaTextArr,
      selectedOptions: [],
      station_names:[],
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        exclusive_field_id: '',
        state: "1",
        is_general:"1",
        recharge_amount:0,
        gift_amount:0,
      },
      status_names:[{name:'启用',val:1},{name:'停用',val:0}],
      // rules表单验证
      rules: {
      },
      formInline: {
        page: 1,
        limit: 10,
        exclusive_field_id: '',
        state: '',
        is_general:'',
      },
      // 删除部门
      seletedata: {
        ids: '',
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getStationNames()
    this.getdata()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    getStationNames(){
      getStationNames().then(res => {
        if (res.code == 0) {
            this.station_names = res.data
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },
    // 获取公司列表
    getdata() {
      this.loading = true
      getCards(this.formInline).then(res => {
          this.loading = false
          this.listData = res.data
          this.pageparm.currentPage = res.meta.current_page
          this.pageparm.pageSize = res.meta.per_page
          this.pageparm.total = res.meta.total

      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.exclusive_field_id = row.exclusive_field_id
        this.editForm.state = row.state
        this.editForm.is_general = row.is_general
        this.editForm.recharge_amount = row.recharge_amount/100
        this.editForm.gift_amount = row.gift_amount > 0 ? row.gift_amount/100 :0
        this.editForm.id = row.id
      } else {
        this.title = '添加'
        this.editForm =  {
          exclusive_field_id: '',
          state: "1",
          is_general:"1",
          recharge_amount:0,
          gift_amount:0,
        }
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          this.editForm.recharge_amount = this.editForm.recharge_amount*100
          this.editForm.gift_amount = this.editForm.gift_amount*100
          if( this.editForm.is_general == 0){
            this.editForm.exclusive_field_id = ''
          }
          console.log( this.editForm)
          if(this.editForm.id){
            updateCards(this.editForm.id,this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code ==0) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          }else{
            addCards(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code ==0) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '添加成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('添加失败，请稍后再试！')
            })
          }
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteCards(index, row) {
      this.$confirm('此操作将删除该模型, 是否继续?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteCards(row.id)
            .then(res => {
              if (res.code == 0 ) {
                this.$message({
                  type: 'success',
                  message: '已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/card/Card.vue